import { createEntityAdapter, EntityState } from "@ngrx/entity";
import { createReducer, on } from "@ngrx/store";
import {
  ImaxxActions,
  TreatmentPageActions,
  TreatmentPlanApiActions,
} from "../actions/action-index";
import { mapFees } from "./maps";
import { Fee } from "./models/fee";

export const featureKey = "fees";

export type FeeState = EntityState<Fee>;

export const adapter = createEntityAdapter<Fee>({
  selectId: (fee: Fee) => fee.id,
  sortComparer: false,
});

export const initialState: FeeState = adapter.getInitialState();

export const reducer = createReducer(
  initialState,
  on(TreatmentPlanApiActions.loadSuccess, (state, { contract }) =>
    adapter.setAll(
      contract.TreatmentPlans.map((tp) => mapFees(tp)).reduce(
        (cv, pv) => cv.concat(...pv),
        []
      ),
      state
    )
  ),
  on(TreatmentPageActions.createExpense, (state, { fee }) =>
    adapter.addOne(fee, state)
  ),
  on(TreatmentPageActions.createExpenses, (state, { fees }) =>
    adapter.addMany(fees, state)
  ),
  on(TreatmentPageActions.feeUpdated, (state, { entity }) =>
    adapter.updateOne(entity, state)
  ),
  on(TreatmentPageActions.expenseRemoved, (state, { id }) =>
    adapter.removeOne(id, state)
  ),
  on(TreatmentPageActions.treatmentPlanRemoved, (state, { id }) =>
    adapter.removeMany(
      Object.keys(state.entities).filter(
        (k) => state.entities[k].treatmentPlanId === id
      ),
      state
    )
  ),
  on(
    TreatmentPageActions.treatmentPlanTemplateAdded,
    (state, { treatmentOptionFee, treatmentFee }) =>
      adapter.addMany([treatmentFee, treatmentOptionFee], state)
  ),
  on(
    TreatmentPlanApiActions.createTreatmentPlanSuccess,
    (state, { originalId, treatmentPlan }) => {
      if (treatmentPlan) {
        return adapter.addMany(
          mapFees(treatmentPlan),
          adapter.removeMany(
            Object.keys(state.entities).filter(
              (k) => state.entities[k].treatmentPlanId === originalId
            ),
            state
          )
        );
      } else {
        return state;
      }
    }
  ),
  on(
    TreatmentPlanApiActions.createTreatmentPlanOptimizerSuccess,
    (state, { originalId, imaxxOptimized }) => {
      if (imaxxOptimized) {
        return adapter.addMany(
          mapFees(imaxxOptimized.TreatmentPlan),
          adapter.removeMany(
            Object.keys(state.entities).filter(
              (k) => state.entities[k].treatmentPlanId === originalId
            ),
            state
          )
        );
      } else {
        return state;
      }
    }
  ),
  on(ImaxxActions.updateImaxxOptimizerSuccess, (state, { TreatmentPlan }) => {
    if (TreatmentPlan) {
      const newState = adapter.removeMany(
        Object.keys(state.entities).filter(
          (k) =>
            state.entities[k].treatmentPlanId === TreatmentPlan.TreatmentPlanId
        ),
        state
      );
      return adapter.addMany(mapFees(TreatmentPlan), newState);
    } else {
      return state;
    }
  }),
  on(ImaxxActions.optimizedCalculateSuccess, (state, { TreatmentPlan }) => {
    if (TreatmentPlan) {
      const newState = adapter.removeMany(
        Object.keys(state.entities).filter(
          (k) =>
            state.entities[k].treatmentPlanId === TreatmentPlan.TreatmentPlanId
        ),
        state
      );
      return adapter.addMany(mapFees(TreatmentPlan), newState);
    } else {
      return state;
    }
  })
);
